import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errMsg, useApi } from "@/lib/api";

export default function SaveTemplateDialog({ project, open, onOpenChange, onSaved }) {
  const api = useApi();
  const [f, setF] = useState({ name: "", category: "", description: "", keep_client_images: false });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open && project) setF({ name: `${project.name} · template`, category: project.sector || "", description: "", keep_client_images: false }); }, [open, project]);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/projects/${project.id}/save-template`, f);
      toast.success(`Template «${data.name}» salvato`, { description: "Lo trovi in Dashboard → Template." });
      onSaved?.(data); onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="save-template-dialog">
        <DialogHeader>
          <DialogTitle>Salva come template</DialogTitle>
          <DialogDescription>Crea una copia congelata e riutilizzabile di questo sito: le modifiche future al progetto non cambiano il template.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5"><Label className="text-xs">Nome del template</Label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="template-name-input" /></div>
          <div className="space-y-1.5"><Label className="text-xs">Categoria / settore</Label><Input value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} placeholder="Es. Spa e benessere" data-testid="template-category-input" /></div>
          <div className="space-y-1.5"><Label className="text-xs">Descrizione</Label><Textarea rows={2} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} placeholder="Per quali clienti è adatto, flussi inclusi…" data-testid="template-description-input" /></div>
          <label className="flex items-start gap-2 text-sm text-slate-700" data-testid="template-keep-images">
            <Checkbox checked={f.keep_client_images} onCheckedChange={(v) => setF({ ...f, keep_client_images: !!v })} className="mt-0.5" data-testid="template-keep-images-checkbox" />
            <span>Includi le foto caricate dal cliente <span className="text-slate-500">(solo se autorizzato; altrimenti vengono sostituite con foto stock)</span></span>
          </label>
          <p className="text-[11px] text-slate-500" data-testid="template-data-note">Non vengono copiati brief, chat, versioni né il logo del cliente (sostituito da un logo testuale). I testi restano com'erano, compresi nome e contatti scritti nelle pagine: vengono sostituiti ogni volta che crei un nuovo sito da questo template.</p>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button onClick={save} disabled={busy || !f.name.trim()} className="bg-navy-900 hover:bg-navy-800" data-testid="template-save-btn">{busy && <Loader2 size={14} className="mr-1.5 animate-spin" />}Salva template</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
